import { render, staticRenderFns } from "./groupH.vue?vue&type=template&id=b5372f5e&scoped=true"
import script from "./groupH.vue?vue&type=script&lang=js"
export * from "./groupH.vue?vue&type=script&lang=js"
import style0 from "./groupH.vue?vue&type=style&index=0&id=b5372f5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5372f5e",
  null
  
)

export default component.exports